export const SCRIPT_LIST = 'SCRIPT_LIST';
export const SCRIPT_LIST_SUCCESS = 'SCRIPT_LIST_SUCCESS';
export const SCRIPT_LIST_ERROR = 'SCRIPT_LIST_ERROR';

export const ADD_SCRIPT_LIST = 'ADD_SCRIPT_LIST';
export const ADD_SCRIPT_LIST_SUCCESS = 'ADD_SCRIPT_LIST_SUCCESS';
export const ADD_SCRIPT_LIST_ERROR = 'ADD_SCRIPT_LIST_ERROR';

export const SCRIPT_LIST_DETAILS = 'SCRIPT_LIST_DETAILS';
export const SCRIPT_LIST_DETAILS_SUCCESS = 'SCRIPT_LIST_DETAILS_SUCCESS';
export const SCRIPT_LIST_DETAILS_ERROR = 'SCRIPT_LIST_DETAILS_ERROR';

export const SCRIPT_LIST_UPDATE = 'SCRIPT_LIST_UPDATE';
export const SCRIPT_LIST_UPDATE_SUCCESS = 'SCRIPT_LIST_UPDATE_SUCCESS';
export const SCRIPT_LISTL_UPDATE_ERROR = 'SCRIPT_LISTL_UPDATE_ERROR';

export const DELETE_SCRIPT_LIST = 'DELETE_SCRIPT_LIST';
export const DELETE_SCRIPT_LIST_ERROR = 'DELETE_SCRIPT_LIST_ERROR';
export const DELETE_SCRIPT_LIST_SUCCESS = 'DELETE_SCRIPT_LIST_SUCCESS';